module.exports = __webpack_public_path__ + "img/fail.8ecec5e4.svg";